import { render, staticRenderFns } from "./CarrierLogs.vue?vue&type=template&id=15782e35&scoped=true&"
import script from "./CarrierLogs.vue?vue&type=script&lang=js&"
export * from "./CarrierLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15782e35",
  null
  
)

export default component.exports